import { categories } from "entities/customerTickets/constants";

export const findCategoryKey = (message: string): string => {
  for (const category of categories) {
    if (category.title === message) {
      return category.key;
    }
    if (category.subCategories) {
      for (const subCategory of category.subCategories) {
        if (subCategory.title === message) {
          return subCategory.key;
        }
      }
    }
  }
  return message;
};
